import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Services',
    href: '#services'
  }, {
    name: 'About',
    href: '#about'
  }, {
    name: 'Contact',
    href: '#contact'
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'glass-nav py-4 shadow-sm' : 'bg-transparent py-6'}`} data-id="element-94">
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between" data-id="element-95">
        <a href="#" className="text-2xl font-extrabold tracking-tight text-navy" data-id="element-96">
          Nexora<span className="text-[#FF6B35]" data-id="element-97">Virtual</span>
        </a>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center space-x-8" data-id="element-98">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-semibold text-gray-800 hover:text-[#FF6B35] transition-colors" data-id="element-99">
              {link.name}
            </a>)}
          <a href="https://wa.me/447921876472?text=Hi%20Nexora%20Virtual%2C%20I%27d%20like%20to%20start%20a%20project" target="_blank" rel="noopener noreferrer" className="px-5 py-2.5 bg-[#FF6B35] text-white text-sm font-bold rounded-full hover:bg-[#F7931E] transition-colors shadow-lg shadow-orange-500/30" data-id="element-100">
            Get Started
          </a>
        </div>

        {/* Mobile Menu Button */}
        <button className="md:hidden p-2 text-gray-800" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-101">
          {isMobileMenuOpen ? <X size={24} data-id="element-102" /> : <Menu size={24} data-id="element-103" />}
        </button>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-104">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-white border-b border-gray-100 overflow-hidden" data-id="element-105">
            <div className="px-6 py-8 flex flex-col space-y-4" data-id="element-106">
              {navLinks.map(link => <a key={link.name} href={link.href} className="text-lg font-semibold text-gray-800" onClick={() => setIsMobileMenuOpen(false)} data-id="element-107">
                  {link.name}
                </a>)}
              <a href="https://wa.me/447921876472?text=Hi%20Nexora%20Virtual%2C%20I%27d%20like%20to%20start%20a%20project" target="_blank" rel="noopener noreferrer" className="inline-block text-center px-5 py-3 bg-[#FF6B35] text-white font-bold rounded-lg" onClick={() => setIsMobileMenuOpen(false)} data-id="element-108">
                Get Started
              </a>
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}